export default __webpack_public_path__ + "static/media/warning--wild-animals--g4.85a2983f.png";